import styled, { css } from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'
import { ReactComponent as EditSvg } from 'src/components/Icons/Basic/icons_edit.svg'
import { ChevronSVG } from 'src/components/Icons/Basic'

export const PopupButtonContainer = styled.div<{
  $size?: 'small' | 'medium'
  $isDisabled?: boolean
  $noBorder?: boolean
}>`
  display: flex;
  position: relative;
  border-radius: 20px;
  padding: ${({ $isDisabled }) =>
    $isDisabled ? '8px 18px' : '8px 8px 8px 18px'};
  border: ${({ $noBorder }) =>
    $noBorder ? 'none' : `1px solid ${palette.neutral[200]}`};
  background: ${palette.neutral.white};
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'default' : 'pointer')};
  height: ${({ $size }) => ($size === 'small' ? '24px' : '40px')};
  gap: 10px;
  transition: background 0.15s ease-in-out;
  align-items: center;
  justify-content: flex-start;
  font-size: ${({ $size }) => ($size === 'small' ? '10px' : '14px')};

  ${({ $isDisabled }) =>
    !$isDisabled &&
    css`
      &:hover {
        background: ${palette.neutral[40]};
      }
    `}
`

export const StyledEditIcon = styled(EditSvg)<{
  $size?: 'small' | 'medium'
}>`
  width: ${({ $size }) => ($size === 'small' ? '14px' : '16px')};
  height: ${({ $size }) => ($size === 'small' ? '14px' : '16px')};
`
export const PopupButtonLabel = styled.p<{
  $size?: 'small' | 'medium'
}>`
  font-weight: 400;
  font-size: ${({ $size }) => ($size === 'small' ? '11px' : '14px')};
  line-height: 150%;
  white-space: nowrap;
`

export const PopupMenuContent = styled.div`
  display: flex;
  position: relative;
  padding: 12px;
  flex-direction: column;
  gap: 8px;
`

export const PopupMenuOption = styled.div<{ background?: string }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  border-radius: 8px;
  width: 100%;
  cursor: pointer;
  ${({ background }) => background && `background: ${background};`}
  transition: background 0.15s ease-in-out;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;

  &:hover {
    filter: brightness(0.9);
  }
`

export const ChevronIcon = styled(ChevronSVG)<{ $open: boolean }>`
  transform: ${({ $open }) => ($open ? 'rotate(-90deg)' : 'rotate(90deg)')};
  width: 10px;
  height: 10px;
  path {
    fill: ${palette.neutral[600]};
  }
`
